import React from "react";

import { useTranslation } from "react-i18next";

function Social () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] xl:mx-auto relative">
                <div className="flex flex-col xl:flex-row gap-[15px]">
                    <div className="bg-[#272727] px-[30px] py-[50px]">
                        <p className="text-[#F26522] text-[14px] xl:text-[16px] font-[600]">{t('about.15')}</p>
                        <p className="mt-[15px] font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6] open-sans">{t('about.16')}</p>
                        <p className="mt-[15px] font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6] open-sans">{t('about.17')}</p>
                    </div>
                    <div className="bg-[#272727] px-[30px] py-[50px]">
                        <p className="text-[#F26522] text-[14px] xl:text-[16px] font-[600]">{t('about.18')}</p>
                        <p className="mt-[15px] font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6] open-sans">{t('about.19')}</p>
                        <p className="mt-[15px] font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6] open-sans">{t('about.20')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Social;